import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { StyledLayout, StyledContent } from "./styles";
import { Outlet } from "react-router-dom";
import httpClient from "../../../api/httpClient";
import { Grid, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getMe } from "../../../store/user/thunks";
import { useWebSocket } from "../../../hooks/useWebSocket";
import { requestNotificationPermission } from "../../../utils/notificationService";
import { selectGetMeLoading } from "../../../store/user/selectors";
import TenantsModal from "./TenantsModal";
const { useBreakpoint } = Grid;

const AppLayout = () => {
  const { md } = useBreakpoint();
  const [collapsed, setCollapsed] = useState(true);
  const loading = useSelector(selectGetMeLoading);

  const dispatch = useDispatch();

  const acesstoken = httpClient.getAccessToken();

  useWebSocket();

  useEffect(() => {
    if (!acesstoken) httpClient.redirectToLogin();
  }, [acesstoken]);

  useEffect(() => {
    if (acesstoken) dispatch(getMe());
    requestNotificationPermission();
  }, []);

  return (
    <>
      <TenantsModal />
      {acesstoken && (
        <StyledLayout>
          {loading ? (
            <div className="h-100 flex-center">
              <Spin size="large" />
            </div>
          ) : (
            <>
              {md && (
                <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
              )}
              <StyledLayout>
                {!md && <Topbar />}

                <StyledContent
                  // @ts-ignore
                  sidebarCollapsed={true}
                >
                  <Outlet />
                </StyledContent>
              </StyledLayout>
            </>
          )}
        </StyledLayout>
      )}
    </>
  );
};

export default AppLayout;
